module.exports = __webpack_public_path__ + "static/media/size_16_on.a9881bca.svg";